module.exports = __webpack_public_path__ + "static/media/KOF14.834dd66.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/KOF14.mp4
// module id = 3QyL
// module chunks = 0